export default "__VITE_ASSET__B6yB5M1r__"